import React from "react";
import "./aboutUs.scss";

const AboutUs: React.FC = () => {
  return (
    <section className="about">
      <div className="about__container">
        <div className="about__content">
          <span className="about__eyebrow">O nas</span>

          <h2 className="about__title">
            Budujemy solidnie.
            <br />
            Tworzymy na lata.
          </h2>

          <p className="about__text">
            Jesteśmy firmą budowlaną, która łączy wieloletnie doświadczenie z
            nowoczesnym podejściem do realizacji inwestycji.
          </p>

          <p className="about__text">
            Każda realizacja jest prowadzona z pełnym zaangażowaniem i dbałością
            o każdy szczegół – od pierwszych ustaleń aż po finalne wykończenie.
            Stawiamy na wysoką jakość wykonania, terminowość oraz indywidualne
            podejście do każdego klienta.
          </p>
          <p className="about__text">
            Doświadczenie, zaangażowanie i dbałość o szczegóły pozwalają nam
            realizować inwestycje solidnie i zgodnie z oczekiwaniami naszych
            klientów.
          </p>

          <div className="about__footer">
            <div className="about__signature">
              <strong className="about__name">Adrian Lada</strong>
              <span className="about__role">Właściciel firmy</span>
            </div>
          </div>
        </div>

        <div className="about__media">
          <div className="about__image-wrapper">
            <img
              className="about__image"
              src="/images/painter.png"
              alt="Adrian Lada, właściciel firmy budowlanej"
            />
          </div>

          <div className="about__badge">
            <span className="about__badge-number">8+</span>
            <span className="about__badge-text">lat doświadczenia</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
